<template>
  <div class="act-float" :class="cssType">
    <div class="float-btn top-up" @click="handleTopUp">¥</div>
    <div class="float-btn customer-service" @click="handleCustom">?</div>
    <div class="float-btn to-top" @click="handleTop">︿</div>
  </div>
</template>

<script setup>
import { watch, nextTick, defineEmits } from 'vue'
import { isMobile, loadScript } from '@/utils'
import { useI18n } from 'vue-i18n'
import { loadingService } from '@/utils/loadingService'
import { aihelpLangOptions } from '@/config/lang'

const emit = defineEmits(['top-up'])
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'

// 与正文共用充值入口，统一上报后再跳转。
const handleTopUp = () => {
  emit('top-up')
}

const handleTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const handleCustom = async () => {
  const aihelpLang = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
  if (!window.AIHelpSupport) {
    await loadScript('https://cdn.aihelp.net/webchatv5/aihelp.js')
  }
  const initConfig = {
    domain: 'miniwantechnologycolimited.aihelp.net',
    appId: 'miniwantechnologycolimited_platform_36bbfccee53e93eeaa51b18afe074c83',
    language: aihelpLang,
  }
  watch(locale, () => {
    if (window.AIHelpSupport) {
      const language = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
      window.AIHelpSupport.updateSDKLanguage(language)
    }
  })
  nextTick(() => {
    loadingService.show()
    window.AIHelpSupport.initialize(initConfig)
    window.AIHelpSupport.registerAsyncEventListener('initialization', function (jsonData) {
      if (jsonData.isSuccess) {
        window.AIHelpSupport.show('E001')
        loadingService.hide()
      }
    })
    window.AIHelpSupport.registerAsyncEventListener('sessionClose', () => {
      loadingService.hide()
    })
  })
}
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
